import fetch from '@/api/fetch'

/** 查询项目信息 */
export const getWorkProjectByProjectId = projectId => fetch.get(`/work/project/id/${projectId}`)

/** 查询项目考勤列表 */
export const getWorkAttendanceByQuery = params => fetch.post('/work/query/list', params);

/** 导出项目考勤列表 */
export const exportWorkAttendanceByQuery = params => fetch.post('/work/query/export', params, {responseType: 'blob'});

/** 按人员统计项目考勤列表 */
export const statisticsWorkAttendanceByQuery = params => fetch.post('/work/statis/list', params);

/** 按人员统计项目考勤导出 */
export const exportStatisticsWorkAttendanceByQuery = params => fetch.post('/work/statis/export', params, {responseType: 'blob'});


/** 按人员统计项目考勤列表 */
export const getProjectUserWorkAttendances = params => fetch.post('/work/project/user', params);
